module.exports = __webpack_public_path__ + "img/income-variable.a5ee6bfb.png";